import { CookieOptionsKeys, CookieOptionsValues } from "~/types/entities";

export const getCookie = (cookiePolicyKey: string) => {
  return (
    document.cookie.split(";").find((cookie) => {
      return cookie.trim().startsWith(cookiePolicyKey);
    }) || ""
  );
};

export function getParsedCookie(
  cookiePolicyKey: string
): CookieOptionsValues | null {
  const allsportsAgr = document.cookie.split(";").find((cookie) => {
    return cookie.trim().startsWith(cookiePolicyKey);
  });

  const trimmedAllsportsAgr = allsportsAgr?.trim();
  if (!trimmedAllsportsAgr) {
    return null;
  }
  const regex = new RegExp(`${cookiePolicyKey}=`, "g");
  const allsportsAgrVal = decodeURIComponent(
    trimmedAllsportsAgr.replace(regex, "")
  );

  const parsedAllsportsAgrVal = JSON.parse(
    allsportsAgrVal
  ) as CookieOptionsValues;

  const requiredKeys = Object.values(CookieOptionsKeys);

  const allKeysPresent = Object.keys(parsedAllsportsAgrVal).every(
    (key) => requiredKeys.includes(key as CookieOptionsKeys)
  );

  if (allKeysPresent) {
    return parsedAllsportsAgrVal;
  }

  return null;
}
